import React from "react";

/**
 * Per-source citation for a Glossary entry.
 *
 * api.hvd_source_variable has one row per variable per year, each naming the
 * file (source_name) that year came from. Its apa_ref string pastes the
 * variable's WHOLE year list next to a single source name, which is wrong as
 * soon as a variable has moved between files (Attendance Rate: District
 * Overview through 2021, District Details since 2022). These helpers fold the
 * rows into one line per source, newest source first, each with its own years.
 */

// Accumulate one row into `sources` ({ [source_name]: { author, years[] } }).
export function addSourceYear(sources, item) {
  if (!item || !item.source_name) return sources;
  const yr = String(item.file_year).slice(0, 4);
  const src = sources[item.source_name] || { author: item.author, years: [] };
  if (!src.years.includes(yr)) src.years.push(yr);
  sources[item.source_name] = src;
  return sources;
}

// "2022–2026" for a contiguous run of 3+ years, else "2019, 2021".
export function yearsText(years) {
  const ys = [...years].sort();
  if (ys.length === 0) return "";
  const contiguous = ys.every((y, i) => i === 0 || Number(y) === Number(ys[i - 1]) + 1);
  return contiguous && ys.length > 2 ? `${ys[0]}–${ys[ys.length - 1]}` : ys.join(", ");
}

// One line per source, newest source first; null when nothing was collected.
export function renderSources(sources) {
  const names = Object.keys(sources || {});
  if (names.length === 0) return null;
  names.sort((a, b) => Math.max(...sources[b].years) - Math.max(...sources[a].years));
  return (
    <span>
      {names.map((name, i) => (
        <span key={name}>
          {i > 0 && <br />}
          <strong>{name}</strong>
          {sources[name].author ? ` — ${sources[name].author}` : ""}
          {" — "}
          {yearsText(sources[name].years)}
        </span>
      ))}
    </span>
  );
}
